import { IBrand } from '@/models/brands.model';

export const getFileUrlByType = (data: IBrand, type: string) => {
  const brand = data?.files?.find((item) => item.metaType === type);
  return brand?.file?.url;
};
